import { Logger } from '@/utils/logging';

import type { TrackingInterface } from '../_types';
import { BOOK_APPOINTMENT_EVENT } from '../trackingConstants';
import { buildBookAppointmentPayload } from './buildBookAppointmentPayload';
import { META_PIXEL_ID_PATTERN, ensureMetaPixel } from './ensureMetaPixel';

import './metaPixel.types';

export const metaPixelTracker = (): TrackingInterface => ({
  setUserId: () => {},
  track: (message, context) => {
    if (message !== BOOK_APPOINTMENT_EVENT) return;
    const pixelId = context?.shopMetaPixelId;
    if (typeof pixelId !== 'string' || !META_PIXEL_ID_PATTERN.test(pixelId)) {
      Logger.console('[meta-pixel] shop has no Meta pixel; skipping');
      return;
    }
    const payload = buildBookAppointmentPayload(context);
    if (!payload) {
      Logger.error(
        '[meta-pixel] missing saleOrderId; skipping book_appointment',
      );
      return;
    }
    ensureMetaPixel(pixelId);
    window.fbq?.('trackSingleCustom', pixelId, BOOK_APPOINTMENT_EVENT, payload);
  },
});
